var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKlicklySpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "lds-spinner",
    width: "200px",
    height: "200px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    style: {
      backgroundImage: "none",
      backgroundPosition: "initial initial",
      backgroundRepeat: "initial initial"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 15.5,
    rx: 12.22,
    ry: 4.03,
    width: 6,
    height: 15,
    fill: "#DA1781"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    times: "0;1",
    dur: "0.9s",
    begin: "-0.8099999999999999s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(36 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 15.5,
    rx: 12.22,
    ry: 4.03,
    width: 6,
    height: 15,
    fill: "#DA1781"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    times: "0;1",
    dur: "0.9s",
    begin: "-0.72s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 15.5,
    rx: 12.22,
    ry: 4.03,
    width: 6,
    height: 15,
    fill: "#DA1781"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    times: "0;1",
    dur: "0.9s",
    begin: "-0.63s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(108 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 15.5,
    rx: 12.22,
    ry: 4.03,
    width: 6,
    height: 15,
    fill: "#DA1781"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    times: "0;1",
    dur: "0.9s",
    begin: "-0.54s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 15.5,
    rx: 12.22,
    ry: 4.03,
    width: 6,
    height: 15,
    fill: "#DA1781"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    times: "0;1",
    dur: "0.9s",
    begin: "-0.45s",
    repeatCount: "indefinite"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 15.5,
    rx: 12.22,
    ry: 4.03,
    width: 6,
    height: 15,
    fill: "#DA1781"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    times: "0;1",
    dur: "0.9s",
    begin: "-0.36s",
    repeatCount: "indefinite"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(216 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 15.5,
    rx: 12.22,
    ry: 4.03,
    width: 6,
    height: 15,
    fill: "#DA1781"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    times: "0;1",
    dur: "0.9s",
    begin: "-0.27s",
    repeatCount: "indefinite"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(252 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 15.5,
    rx: 12.22,
    ry: 4.03,
    width: 6,
    height: 15,
    fill: "#DA1781"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    times: "0;1",
    dur: "0.9s",
    begin: "-0.18s",
    repeatCount: "indefinite"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(288 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 15.5,
    rx: 12.22,
    ry: 4.03,
    width: 6,
    height: 15,
    fill: "#DA1781"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    times: "0;1",
    dur: "0.9s",
    begin: "-0.09s",
    repeatCount: "indefinite"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(324 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 15.5,
    rx: 12.22,
    ry: 4.03,
    width: 6,
    height: 15,
    fill: "#DA1781"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    times: "0;1",
    dur: "0.9s",
    begin: "0s",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlicklySpinner);
export default __webpack_public_path__ + "static/media/klickly-spinner.5c2cab32abacb726485d250abdd69454.svg";
export { ForwardRef as ReactComponent };